import { EnabledModuleTabsRequestKey } from '~/data/moduleTabs';

// Module & Tabs Config
export type EmployeeModuleTabConfig<TabPath, TabConfigKey, TabInstructionKey> =
  {
    path: TabPath;
    enabledConfigKey: TabConfigKey;
    instructionKey?: TabInstructionKey;
  };

export type EmployeeModuleConfig<TabPath, TabConfigKey, TabInstructionKey> = {
  path: string;
  defaultTab: TabPath;
  enabledTabsRequestKey: EnabledModuleTabsRequestKey;
  tabConfigs: EmployeeModuleTabConfig<
    TabPath,
    TabConfigKey,
    TabInstructionKey
  >[];
};

// Tab Props
export enum EmployeeModuleTabAccessMode {
  Limited = 'limited',
  ITAdmin = 'itAdmin',
  Full = 'full',
}

export type EmployeeModuleTabVariant = 'summary' | undefined;

export type EmployeeModuleTabSetupProps<TabPath> = {
  id: TabPath;
  title: string;
  accessMode?: EmployeeModuleTabAccessMode;
  tabHelp?: string;
  variant?: EmployeeModuleTabVariant;
  prefetchData?: Function;
};

export type EmployeeModuleTabProps<TabPath> = {
  tabId: TabPath;
  title: string;
  href: string;
  disabled?: boolean;
  active?: boolean;
  tabHelp?: string;
  variant?: EmployeeModuleTabVariant;
  prefetchData?: Function;
};
